import Draft, { convertFromHTML } from 'draft-js';

const createEditorState = (html) => {
  let EditorState = Draft.EditorState;
  let ContentState = Draft.ContentState;

  return ({
    editorState: EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(html)))
  })
}

function transformHTMLtoRAW(fields) {
  let EditorState = Draft.EditorState;
  let ContentState = Draft.ContentState;

  const {legalConfiguration, homePageConfiguration, ...rest} = fields;
  const wysiwigFields = [
    legalConfiguration.copyrightLanguage,
    legalConfiguration.privacyPolicy,
    homePageConfiguration.signInMessage
  ];

  const [copyrightLanguage, privacyPolicy, signInMessage] = wysiwigFields.map(html => createEditorState(html))

  return {
    ...rest,
    homePageConfiguration: {
      ...homePageConfiguration,
      signInMessage
    },
    legalConfiguration: {
      ...legalConfiguration,
      copyrightLanguage,
      privacyPolicy
    }
  }
}

export default transformHTMLtoRAW